export const interceptStdout = (stdoutIntercept, stderrIntercept = stdoutIntercept) => {
  if (typeof process !== 'undefined' && process.stdout && process.stderr) {
    // Node.js environment
    return interceptNode(stdoutIntercept, stderrIntercept);
  } else {
    // Browser environment
    return interceptBrowser(stdoutIntercept, stderrIntercept);
  }
};

const interceptNode = (stdoutIntercept, stderrIntercept) => {
  const oldStdoutWrite = process.stdout.write;
  const oldStderrWrite = process.stderr.write;

  process.stdout.write = interceptorWrapper(oldStdoutWrite, stdoutIntercept, process.stdout);
  process.stderr.write = interceptorWrapper(oldStderrWrite, stderrIntercept, process.stderr);

  return function unhook() {
    process.stdout.write = oldStdoutWrite;
    process.stderr.write = oldStderrWrite;
  };
};

const interceptBrowser = (stdoutIntercept, stderrIntercept) => {
  const oldLog = console.log;
  const oldError = console.error;

  console.log = interceptorWrapper(oldLog, stdoutIntercept, console);
  console.error = interceptorWrapper(oldError, stderrIntercept, console);

  return function unhook() {
    console.log = oldLog;
    console.error = oldError;
  };
};

const interceptorWrapper = (originalFunction, interceptFunction, context) => {
  return function (...args) {
    const modifiedArgs = args.map((arg) => {
      const result = interceptFunction(arg);
      return typeof result === 'string' ? result.replace(/\n$/, '') + (result && /\n$/.test(arg) ? '\n' : '') : arg;
    });
    originalFunction.apply(context, modifiedArgs);
  };
};
